import React from "react";
import { Tooltip, Typography } from "antd";
import Highlighter from "react-highlight-words";
import { HighlightResult, parseSearchWords } from "@tailormed/common-client/component/HeaderSearchBar/highlight";
import { shorterString } from "../utils/string";

const { Text } = Typography;

const ShorterText = ({ text, maxLength, searchInput, textStyle, ...props }) => {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: HighlightResult(text, searchInput, maxLength) }}
      style={textStyle}
      {...props}
    ></div>
  );
};

const ShorterTextWithTooltip = ({
  text,
  maxLength,
  searchInput,
  textStyle,
  placement = "right",
  id = undefined,
  ...props
}) => {
  return (
    <>
      {text?.length > maxLength && (
        <Tooltip
          title={<Text>{text}</Text>}
          color={"white"}
          placement={placement}
          id={id ? `tooltip_${id}` : undefined}
        >
          <ShorterText
            text={text}
            maxLength={maxLength}
            searchInput={searchInput}
            textStyle={{ ...textStyle, cursor: "pointer" }}
            id={id}
            {...props}
          />
        </Tooltip>
      )}
      {text?.length <= maxLength && (
        <ShorterText
          text={text}
          maxLength={maxLength}
          searchInput={searchInput}
          textStyle={textStyle}
          id={id}
          {...props}
        />
      )}
    </>
  );
};

const HighlighterShorterTextWithTooltip = ({ text, maxLength, searchInput, ...props }) => {
  const searchWords = parseSearchWords(searchInput);

  return (
    <>
      {text?.length > maxLength && (
        <Tooltip title={<Text style={{ color: "white" }}>{text}</Text>}>
          <Highlighter
            {...props}
            searchWords={searchWords}
            autoEscape
            textToHighlight={shorterString(text, maxLength)}
          />
        </Tooltip>
      )}
      {text?.length <= maxLength && (
        <Highlighter {...props} searchWords={searchWords} autoEscape textToHighlight={text} />
      )}
    </>
  );
};

export { ShorterTextWithTooltip, HighlighterShorterTextWithTooltip, ShorterText };
